"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchOperationType = exports.ManageBatchOperationRequestModes = void 0;
var ManageBatchOperationRequestModes;
(function (ManageBatchOperationRequestModes) {
    ManageBatchOperationRequestModes["STATUS_CHECK"] = "status-check";
    ManageBatchOperationRequestModes["OFF_THE_SHELF"] = "off-the-shelf";
    ManageBatchOperationRequestModes["DOWNLOAD_OFF_THE_SHELF"] = "download-off-the-shelf-qr-codes";
    ManageBatchOperationRequestModes["OFF_THE_SHELF_BATCH_DETAILS"] = "off-the-shelf-batch-details";
    ManageBatchOperationRequestModes["UPDATE_OFF_THE_SHELF_QR_CODES"] = "update-off-the-shelf-qr-codes";
})(ManageBatchOperationRequestModes = exports.ManageBatchOperationRequestModes || (exports.ManageBatchOperationRequestModes = {}));
var BatchOperationType;
(function (BatchOperationType) {
    BatchOperationType["create_ots_qr_codes"] = "create_ots_qr_codes";
})(BatchOperationType = exports.BatchOperationType || (exports.BatchOperationType = {}));
